var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ImagemComFallback',{staticClass:"custom-backgroud",attrs:{"src":_vm.background,"srcDefault":"/assets/imgs/background.svg","id":"background"}},[_c('ImagemComFallback',{staticClass:"custom-loading",attrs:{"src":_vm.logo,"srcDefault":"/assets/imgs/logo.svg","id":"loading"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }